import { render, staticRenderFns } from "./PzYousign.vue?vue&type=template&id=50b73839"
import script from "./PzYousign.vue?vue&type=script&lang=js"
export * from "./PzYousign.vue?vue&type=script&lang=js"
import style0 from "./PzYousign.vue?vue&type=style&index=0&id=50b73839&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b73839')) {
      api.createRecord('50b73839', component.options)
    } else {
      api.reload('50b73839', component.options)
    }
    module.hot.accept("./PzYousign.vue?vue&type=template&id=50b73839", function () {
      api.rerender('50b73839', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/DigitalSings/YousignV3/PzYousign.vue"
export default component.exports